import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clear } from '../../features/auth/authAPI';
import { logout } from '../../features/auth/authSlice';

export default function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const username = useSelector((state) => state.auth.username);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  /* let lastScrollY = 0; */

  /* useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY < lastScrollY);
      if (window.scrollY > lastScrollY || window.scrollY === 0) setIsSticky(false);
      else if (window.scrollY < lastScrollY) setIsSticky(true);
      lastScrollY = window.scrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []); */

  const handleLogout = () => {
    dispatch(logout());
    dispatch(clear());
    navigate('/login');
  };

  return (
    <header
      className={`flex gap-5 justify-between w-full px-10 py-7 transition-all duration-300 z-50 ${isSticky ? 'fixed top-0 bg-zinc-900 shadow-lg' : ''} max-md:px-5 max-md:flex-col max-md:items-start`}
      role="banner"
    >
      <nav
        className={`flex flex-wrap gap-10 self-start text-neutral-900 max-md:flex-col max-md:w-full ${isMenuOpen ? 'max-md:flex' : 'max-md:hidden'}`}
        role="navigation"
        aria-label="Main navigation"
      >
        <Link to="/">
          <div className="flex gap-1 justify-center items-center self-start text-2xl font-extrabold leading-none">
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/0f24a31ac286bed38d7dbd032dfda9cab99e86c2dfccbaff25b137f0b50ac4f7?apiKey=e485b3dc4b924975b4554885e21242bb&"
              alt="Moodeng Credit logo"
              className="object-contain shrink-0 self-stretch my-auto aspect-[0.87] w-[34px]"
            />
            <span className="self-stretch my-auto text-[#222222]">Moodeng Credit</span>
          </div>
        </Link>

        <div className="flex flex-auto gap-10 items-center text-lg tracking-normal leading-10 text-center max-md:flex-col max-md:items-start max-md:w-full">
          <Link to="/guide" className="self-stretch my-auto text-lg text-[#222222] font-semibold hover:text-blue-600 focus:outline-none">
            Guide
          </Link>
          <Link to="/benefits" className="self-stretch my-auto text-lg text-[#222222] font-semibold hover:text-blue-600 focus:outline-none">
            Benefits
          </Link>
          <Link to="/whylend" className="self-stretch my-auto text-lg text-[#222222] font-semibold hover:text-blue-600 focus:outline-none">
            Why Lend
          </Link>
          <Link to="https://moodeng-credit.gitbook.io/moodeng-credit" className="self-stretch my-auto text-lg text-[#222222] font-semibold hover:text-blue-600 focus:outline-none">
            Docs
          </Link>
        </div>
      </nav>

      <div className="flex gap-6 max-md:w-full max-md:justify-between">
        {!username ? <>
          {/* <Link to="/login">
            <div className="flex overflow-hidden gap-5 justify-center items-center self-stretch p-3 my-auto rounded-lg border border-solid border-white border-opacity-20 min-h-[46px] w-[46px]">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path d="M2.00098 11.999L16.001 11.999M16.001 11.999L12.501 8.99902M16.001 11.999L12.501 14.999" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M9.00195 7C9.01406 4.82497 9.11051 3.64706 9.87889 2.87868C10.7576 2 12.1718 2 15.0002 2L16.0002 2C18.8286 2 20.2429 2 21.1215 2.87868C22.0002 3.75736 22.0002 5.17157 22.0002 8L22.0002 16C22.0002 18.8284 22.0002 20.2426 21.1215 21.1213C20.3531 21.8897 19.1752 21.9862 17 21.9983M9.00195 17C9.01406 19.175 9.11051 20.3529 9.87889 21.1213C10.5202 21.7626 11.4467 21.9359 13 21.9827" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"></path>
                </g>
              </svg>
            </div>
          </Link>
          <Link to="/register">
            <div className="flex overflow-hidden gap-5 justify-center items-center self-stretch p-3 my-auto rounded-lg border border-solid border-white border-opacity-20 min-h-[46px] w-[46px]">
              <svg fill="#ffffff" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 236 256" enable-background="new 0 0 236 256" xmlSpace="preserve" stroke="#ffffff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path d="M117.5,2c-12.47,0-22.63,10.16-22.63,22.63c0,12.46,10.06,22.62,22.63,22.62c12.37,0,22.62-10.16,22.62-22.62 C140.12,12.16,129.97,2,117.5,2z M146,52H89c-15.59,0-28,13.41-28,29v32h20V86c0-1.71,1.29-3,3-3s3,1.29,3,3v27h61V86 c0-1.71,1.29-3,3-3s3,1.29,3,3v27h20V81C174,65.51,161.49,52,146,52z M2,118v27h23v109h185V145h24v-27H2z M76.48,227.79l4.24-23.15 L100,223.92L76.48,227.79z M102.29,221.06l-19.08-19.08l47.55-47.54l19.08,19.08L102.29,221.06z M158.45,164.9l-5.99,5.99 l-19.08-19.04l6.02-5.99c1.75-1.79,5.15-1.28,7.54,1.11l10.4,10.4C159.73,159.72,160.23,163.12,158.45,164.9z"></path>
                </g>
              </svg>
            </div>
          </Link> */}
          <button
            type="button"
            onClick={() => navigate('/login')}
            className="px-4 py-2 w-[150px] bg-white/50 text-[#222222] font-semibold rounded-[555px]"
          >
            Login
          </button>
          <button
            type="button"
            onClick={() => navigate('/register')}
            className="px-4 py-2 w-[150px] bg-white/50 text-[#222222] font-semibold rounded-[555px]"
          >
            Register
          </button>
        </> : <>
          <button
            type="button"
            onClick={() => navigate('/dashboard#request')}
            className="px-4 py-2 w-[150px] bg-white/50 text-[#222222] font-semibold rounded-[555px]"
          >
            App
          </button>
          <button
            type="button"
            onClick={() => navigate('/profile')}
            className="px-4 py-2 w-[150px] bg-white/50 text-[#222222] font-semibold rounded-[555px]"
          >
            Profile
          </button>
          <button
            className="px-4 py-2 w-[150px] bg-white/50 text-[#222222] font-semibold rounded-[555px]"
            onClick={handleLogout}
            aria-label="Log Out"
          >
            Log Out
          </button>
          {/* <Link to="/dashboard#request">
            <div className="flex overflow-hidden gap-5 justify-center items-center self-stretch p-3 my-auto rounded-lg border border-solid border-white border-opacity-20 min-h-[46px] w-[46px]">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path d="M3 8.976C3 4.05476 4.05476 3 8.976 3H15.024C19.9452 3 21 4.05476 21 8.976V15.024C21 19.9452 19.9452 21 15.024 21H8.976C4.05476 21 3 19.9452 3 15.024V8.976Z" stroke="#ffffff" stroke-width="2"></path>
                  <path d="M21 9L3 9" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M9 21L9 9" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
              </svg>
            </div>
          </Link>
          <Link to="/profile">
            <div className="flex overflow-hidden gap-5 justify-center items-center self-stretch p-3 my-auto rounded-lg border border-solid border-white border-opacity-20 min-h-[46px] w-[46px]">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path d="M12.12 12.78C12.05 12.77 11.96 12.77 11.88 12.78C10.12 12.72 8.71997 11.28 8.71997 9.50998C8.71997 7.69998 10.18 6.22998 12 6.22998C13.81 6.22998 15.28 7.69998 15.28 9.50998C15.27 11.28 13.88 12.72 12.12 12.78Z" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M18.74 19.3801C16.96 21.0101 14.6 22.0001 12 22.0001C9.40001 22.0001 7.04001 21.0101 5.26001 19.3801C5.36001 18.4401 5.96001 17.5201 7.03001 16.8001C9.77001 14.9801 14.25 14.9801 16.97 16.8001C18.04 17.5201 18.64 18.4401 18.74 19.3801Z" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
              </svg>
            </div>
          </Link>
          <Link to="/login">
            <div onClick={handleLogout} className="flex overflow-hidden gap-5 justify-center items-center self-stretch p-3 my-auto rounded-lg border border-solid border-white border-opacity-20 min-h-[46px] w-[46px]">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path d="M15 12L2 12M2 12L5.5 9M2 12L5.5 15" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M9.00195 7C9.01406 4.82497 9.11051 3.64706 9.87889 2.87868C10.7576 2 12.1718 2 15.0002 2L16.0002 2C18.8286 2 20.2429 2 21.1215 2.87868C22.0002 3.75736 22.0002 5.17157 22.0002 8L22.0002 16C22.0002 18.8284 22.0002 20.2426 21.1215 21.1213C20.3531 21.8897 19.1752 21.9862 17 21.9983M9.00195 17C9.01406 19.175 9.11051 20.3529 9.87889 21.1213C10.5202 21.7626 11.4467 21.9359 13 21.9827" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"></path>
                </g>
              </svg>
            </div>
          </Link> */}
        </>}
        <button
          className="flex overflow-hidden gap-5 justify-center items-center px-2.5 py-2 rounded-lg border border-solid border-white border-opacity-20 min-h-[42px] md:hidden hover:bg-gray-100 focus:outline-none"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation menu"
        >
          <img
            src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/0f24a31ac286bed38d7dbd032dfda9cab99e86c2dfccbaff25b137f0b50ac4f7?apiKey=e485b3dc4b924975b4554885e21242bb&"
            alt=""
            className="object-contain self-stretch my-auto w-7 aspect-square"
            aria-hidden="true"
          />
        </button>
      </div>
    </header>
  );
}
